<template>
    <div>
        <div class="with-absolute-button">
            <multi-select class="light-bg" v-model="localSelectedFilingClassificationPlanItem" label="name" track-by="id" open-direction="bottom"
                :options="filingClassificationPlanList" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" 
                :close-on-select="true" :allow-empty="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" 
                :multiple="false" :placeholder="$t('res_Label_SelectOption')" @search-change="getAllFilingClassificationPlans" :disabled="disabled"
                @input="handleSelectedChangedFromTree" @close="sendingDesignatedPersonsList = []">
                <template slot="option" slot-scope="props">
                    <div style="height: 50px; width: 100%; display: flex;text-align:start">
                        <div class="" style="">
                            <v-avatar color="#eff2f5" size="43">{{ utils.CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box">
                            <p class="ad__text__bold">{{ props.option.name }} {{ props.option.parent ? '/ ' + props.option.parent.name : '' }}</p>
                        </div>
                    </div>
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button @click="openFilingClassificationPlanDialog()" :disabled="disabled">
                <v-icon class="float-right">mdi-format-list-group-plus</v-icon>
            </button>
        </div>

        <v-dialog v-model="showFilingClassificationPlanDialog" content-class="dialog2 address-book-dialog with-fixed-actions">
            <div class="dialog-header" style="z-index: 3000 !important;">
                <h1>{{ mode == filingClassificationPlanMode.FilingPlanMode ? $t("res_label_FilingPlan") : $t("res_label_ClassificationPlan") }}</h1>
            </div>
            <div class="dialog-body white-container">
                <FilingClassificationPlanTree @close-dialog="closeFilingClassificationPlanDialog"
                        @handleSelectedChanged="handleSelectedChangedFromTree"
                        :mode="mode"
                        :key="treeResetKey"
                        :reset="treeResetKey"
                        :selectedItem="localSelectedFilingClassificationPlanItem"
                        :showHierarchicalData="true">
                </FilingClassificationPlanTree>
            </div>
        </v-dialog>

    </div>
</template>
<script>
    import MultiSelect from 'vue-multiselect';
    import constants from '@/assets/js/constants';
    import axios from 'axios';
    import FilingClassificationPlanTree from '../components/FilingClassificationPlanTree.vue';
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'FilingClassificationPlanSelector',
        components: { MultiSelect, FilingClassificationPlanTree },
        props: {
            mode: { type: Number, default: 3 }, // 1 => FilingPlanMode, 2 => ClassificationPlanMode, 3 => BothPlanModes
            selectedFilingPlan: { type: Object, default: null },
            selectedClassificationPlan: null,
            structureId: Number,
            disabled: { type: Boolean, default: false }
        },
        data() {
            return {
                filingClassificationPlanMode: {
                    FilingPlanMode: 1,
                    ClassificationPlanMode: 2,
                    BothPlanModes: 3
                },
                loading: false,
                filingClassificationPlanList: [],
                localSelectedFilingClassificationPlanItem: null,
                showFilingClassificationPlanDialog: false,
                utils: utils,
                treeResetKey: 1,
            };
        },
        watch:{
            selectedFilingPlan: function(val){
                if(val != null && val != undefined)
                    this.handleSelectedChangedFromTree(val)
            },
            selectedClassificationPlan: function(val){
                if(val != null && val != undefined)
                    this.handleSelectedChangedFromTree(val)
            }
        },
        methods: {
            getAllFilingClassificationPlans(searchText = "") {
                this.filingClassificationPlanList = [];
                this.loading = true;
                axios.get(constants.baseApiUrl + 'Admin/GetAllFilingClassificationPlansHierarchical?search=' + searchText
                    + '&mode=' + this.mode
                    + '&structureId=' + (this.structureId > 0 ? this.structureId : ''))
                    .then(res => {
                        if (res != null && res.data != null) {
                            this.filingClassificationPlanList = res.data.filter(option => !option.readOnly);
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => { this.loading = false; })
            },
            handleSelectedChangedFromTree(item) {
                this.localSelectedFilingClassificationPlanItem = item;

                if (this.mode == this.filingClassificationPlanMode.FilingPlanMode)
                    this.$emit('FilingPlanSelectChanged', item);
                else if (this.mode == this.filingClassificationPlanMode.ClassificationPlanMode)
                    this.$emit('ClassificationPlanSelectChanged', item);
                else
                    this.$emit('FilingClassificationPlanSelectChanged', item);

                this.filingClassificationPlanList = [];
            },
            openFilingClassificationPlanDialog() {
                this.treeResetKey = new Date().valueOf() + 1;
                this.showFilingClassificationPlanDialog = true;
                // this.$emit('FilingClassificationSelected', this.localSelectedFilingClassificationPlanItem);
            },
            closeFilingClassificationPlanDialog() {
                this.showFilingClassificationPlanDialog = false;
            },
        },
    };
</script>;